import CustomerNavbar from './policynavbar'
import { Select, Label, Button, Container, Row, Column,Panel,Spinner } from '../components'
import { Route, Switch } from 'react-router-dom'
import PrivateRoute from '../shared/components/PrivateRoute'
import TextInputWithLabelInline from '../shared/components/input/TextInputWithLabelInline'
import { createContext, useEffect, useState, useRef } from 'react'
import '../../src/cs2common.css'
import InputGroup from 'react-bootstrap/InputGroup'
import { Icon } from '../components/components/Icon/index'
import { FloatingLabel, Form } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import PolicyNavbar from './policynavbar'
import UnmatchedPolicies from './PolicyAssigment/LeftPanel/unmatched-policies'
import StatisticsDashboard from './Statistics/statisticsDashboard'
import { Redirect } from 'react-router-dom';
import UserStatisticsDashboard from './Statistics/userStatisticsDashboard'

interface Props {
  isSideBarCollapsed: boolean
}

const PolicyDashboard = (props:Props) => {
    const history = useHistory()
    const [highlightedMenu,setHighlightedMenu] = useState('unmatched-Policy');
    function highlightMenu(){
        var tabLink = document.querySelectorAll(".nav-link");
        tabLink.forEach(function (item) {
          item.classList.remove("active");
        });

        const path = window.location.pathname;
        let activeMenu = '';
        if (path.includes('unmatched-policies')) {
            activeMenu = 'Policy Assignment';

        } else if (path.includes('userStatisticsDashboard')) {          
            activeMenu = 'User Statistics';
        } else if (path.includes('statisticsDashboard')) {
            activeMenu = 'Statistics';
        }

        tabLink.forEach(function (item) { 
          if(item.id===activeMenu){
            item.classList.add("active");
          }
        });
        history.push(location)
        setHighlightedMenu(activeMenu)
      }
    
       useEffect(()=>{
         setTimeout(() => {
           highlightMenu()
       }, 2000)
         
       },[])
 
  useEffect (() => {
    const root =document.documentElement;
    root.style.setProperty('--marginLeftCustomerRow', props.isSideBarCollapsed ? '100px' : '250px')
  },[props.isSideBarCollapsed]);

    return (
        <div className='bg-light' style={{ height: 'calc(100vh - 50px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div className='d-flex justify-content-between align-items-center' style={{ flexShrink: 0 }}>
            <PolicyNavbar />
          </div>

          <Container fluid className='px-4 mt-2' style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
            <Row className='bg-light'>
              <Column lg={12}>
                        <Switch>
                            <Route
                                exact
                                path="/UnmatchedPolicy/PolicyAssigment/LeftPanel/unmatched-policies"
                                component={UnmatchedPolicies}
                            />
                            <Route
                                exact
                                path="/UnmatchedPolicy/Statistics/statisticsDashboard"
                                component={StatisticsDashboard}
                            />
                            <Route
                                exact
                                path="/UnmatchedPolicy/Statistics/userStatisticsDashboard"
                                component={UserStatisticsDashboard}
                            />
                            <Route
                                exact
                                path="/UnmatchedPolicy/PolicyAssigment/unmatched-policy"
                                render={() => (
                                    <Redirect to="/UnmatchedPolicy/PolicyAssigment/LeftPanel/unmatched-policies" />
                                )}
                            />
                        </Switch>
                    </Column>
                </Row>
            </Container>

          

          {/* <div className="row">
        <div className="col-lg-12">
        <CustomerDashboardView/>
        </div>
    </div> */}
        </div>
   
   
     
    )
   
}

export default PolicyDashboard